/* Ergosia Upsell Cascade v4 — Loaded as permanent asset */
(function() {
  // ══════════════════════════════════════════════════════════════════
  // ERGOSIA UPSELL CASCADE v4
  // Step 1: -15% (UPSELL15) sur les 4 best-sellers premium
  // Step 2: -20% (UPSELL20) sur les produits complémentaires
  // Discount appliqué via hidden input dans le form — jamais via /discount/
  // ══════════════════════════════════════════════════════════════════

  // ── A/B tracking ──────────────────────────────────────────────────
  var _sid = localStorage.getItem('ergosia_sid');
  if (!_sid) { _sid = Math.random().toString(36).slice(2)+Date.now().toString(36); localStorage.setItem('ergosia_sid',_sid); }
  var _seed = 0; for(var i=0;i<_sid.length;i++) _seed+=_sid.charCodeAt(i);
  function getVariant(){ var t=document.getElementById('ergosia-upsell-trigger'); var w=t&&t.dataset.winner||''; return(w==='A'||w==='B')?w:(_seed%2===0?'A':'B'); }
  function track(ev,extra){ try{ fetch('http://62.238.15.183:8765/ab-track',{method:'POST',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify(Object.assign({variant:getVariant(),event:ev,session_id:_sid},extra||{}))}).catch(function(){}); }catch(e){} }

  // ── Gestion de l'input hidden discount (seule source de vérité checkout) ──
  function setDiscountInput(code) {
    var inp = document.getElementById('ergosia-upsell-discount-input');
    if (inp) inp.value = code || '';
  }

  // ── Désactivation complète ─────────────────────────────────────────
  function deactivateUpsell() {
    sessionStorage.removeItem('ergosia_upsell_active');
    sessionStorage.removeItem('ergosia_upsell_code');
    setDiscountInput('');
    var badge = document.getElementById('ergosia-disc-badge');
    if (badge) badge.remove();
  }

  // ── Badge actif (injecté par JS, survit aux re-renders) ───────────
  var BADGE_ID = 'ergosia-disc-badge';
  function injectBadge() {
    var code = sessionStorage.getItem('ergosia_upsell_code');
    if (!code) return;
    if (document.getElementById(BADGE_ID)) return;
    var footer = document.querySelector('.mini-cart__drawer-footer');
    if (!footer) return;
    var pct = code === 'UPSELL20' ? '20' : '15';
    var color = code === 'UPSELL20' ? '#c0392b' : '#1a7a3c';
    var bg = code === 'UPSELL20' ? '#fff0e8' : '#f0faf5';
    var border = code === 'UPSELL20' ? '#ffaa70' : '#c3e6cd';
    var d = document.createElement('div');
    d.id = BADGE_ID;
    d.style.cssText = 'display:flex;align-items:center;justify-content:space-between;'
      +'background:'+bg+';border:1px solid '+border+';border-radius:6px;padding:6px 10px;margin-bottom:8px;';
    d.innerHTML = '<span style="font-size:11px;font-weight:600;color:'+color+';">🏷 Offre &minus;'+pct+'% activée</span>'
      +'<span style="font-size:11px;font-weight:700;color:'+color+';background:'+border+';padding:2px 7px;border-radius:10px;">'+code+'</span>';
    footer.insertBefore(d, footer.firstChild);
  }

  // ── Check suppression produit upsell ──────────────────────────────
  var _removalTimer = null;
  function scheduleRemovalCheck() {
    clearTimeout(_removalTimer);
    _removalTimer = setTimeout(function() {
      if (!sessionStorage.getItem('ergosia_upsell_code')) return;
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart) {
          var hasStep1 = cart.items.some(function(i){ return i.properties && i.properties['_upsell_step'] === '1'; });
          var hasStep2 = cart.items.some(function(i){ return i.properties && i.properties['_upsell_step'] === '2'; });
          // Le code actif correspond au dernier step accepté
          var currentCode = sessionStorage.getItem('ergosia_upsell_code');
          var shouldHave = (currentCode === 'UPSELL20') ? hasStep2 : hasStep1;
          // Si ni step1 ni step2 : désactiver tout
          if (!hasStep1 && !hasStep2) {
            deactivateUpsell();
          } else if (currentCode === 'UPSELL20' && !hasStep2 && hasStep1) {
            // Step 2 retiré mais step 1 encore là → revenir à UPSELL15
            sessionStorage.setItem('ergosia_upsell_code', 'UPSELL15');
            setDiscountInput('UPSELL15');
            var badge = document.getElementById(BADGE_ID);
            if (badge) badge.remove();
            injectBadge();
          } else if (!shouldHave) {
            deactivateUpsell();
          }
        })
        .catch(function(){});
    }, 600);
  }

  // ── Init au démarrage — nettoyage session périmée ─────────────────
  var initCode = sessionStorage.getItem('ergosia_upsell_code');
  if (initCode) {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart) {
        var hasStep1 = cart.items.some(function(i){ return i.properties && i.properties['_upsell_step'] === '1'; });
        var hasStep2 = cart.items.some(function(i){ return i.properties && i.properties['_upsell_step'] === '2'; });
        if (!hasStep1 && !hasStep2) {
          deactivateUpsell();
        } else {
          // Réactiver : déterminer le bon code
          var activeCode = hasStep2 ? 'UPSELL20' : 'UPSELL15';
          sessionStorage.setItem('ergosia_upsell_code', activeCode);
          setDiscountInput(activeCode);
          injectBadge();
        }
      })
      .catch(function(){});
  }

  // ── MutationObserver global ───────────────────────────────────────
  var _shownTracked = false;
  new MutationObserver(function() {
    if (!_shownTracked && document.getElementById('ergosia-upsell-trigger')) {
      _shownTracked = true;
      track('shown', {step: document.getElementById('ergosia-upsell-trigger')&&document.getElementById('ergosia-upsell-trigger').dataset.offerStep});
    }
    var code = sessionStorage.getItem('ergosia_upsell_code');
    if (code) {
      if (!document.getElementById(BADGE_ID)) injectBadge();
      setDiscountInput(code);
      scheduleRemovalCheck();
    }
  }).observe(document.documentElement, {childList:true, subtree:true});

  // ── Sparkles ──────────────────────────────────────────────────────
  function spawnSparkles(el) {
    var emojis=['✨','⭐','💥','🎉']; var rect=el.getBoundingClientRect();
    for(var i=0;i<5;i++)(function(i){ setTimeout(function(){
      var s=document.createElement('span');
      s.style.cssText='position:fixed;pointer-events:none;font-size:18px;z-index:99999;'
        +'animation:ergosia-sparkle 0.6s ease-out forwards;'
        +'left:'+(rect.left+Math.random()*rect.width)+'px;'
        +'top:'+(rect.top+Math.random()*rect.height*0.5)+'px;';
      s.textContent=emojis[i%emojis.length];
      document.body.appendChild(s);
      setTimeout(function(){ if(s.parentNode) s.remove(); },700);
    },i*70);})(i);
  }

  // ── Délégation globale des clics ──────────────────────────────────
  document.addEventListener('click', function(e) {

    // Tap trigger
    var trigger = e.target.closest('#ergosia-upsell-trigger');
    if (trigger) {
      if (trigger.dataset.revealed) return;
      trigger.dataset.revealed = '1';
      var card = document.getElementById('ergosia-upsell-card');
      if (!card) return;
      var isStep2 = trigger.dataset.offerStep === '2';
      trigger.style.animation = 'ergosia-celebrate 0.45s ease forwards';
      trigger.style.background = isStep2
        ? 'linear-gradient(90deg,#5c1a0d,#c0392b)'
        : 'linear-gradient(90deg,#1a3a5c,#1a7ff1)';
      var tEl=trigger.querySelector('[data-upsell-title]');
      var sEl=trigger.querySelector('[data-upsell-sub]');
      var aEl=trigger.querySelector('[data-upsell-arrow]');
      if(tEl) tEl.style.color='#fff';
      if(sEl) sEl.style.color='rgba(255,255,255,0.8)';
      if(aEl) aEl.style.display='none';
      spawnSparkles(trigger);
      setTimeout(function(){ trigger.style.display='none'; card.classList.add('revealed'); }, 350);
      return;
    }

    // Tap bouton ajouter
    var btn = e.target.closest('.ergosia-upsell-btn');
    if (btn && !btn.disabled) {
      btn.disabled = true;
      var orig = btn.innerHTML;
      btn.innerHTML = '<span style="font-size:16px;">⏳</span>';
      var vid = btn.getAttribute('data-variant-id');
      var step = btn.getAttribute('data-offer-step');
      var code = btn.getAttribute('data-offer-code');

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:vid, quantity:1, properties:{'_upsell_step': step}})
      })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        if (data.status) { btn.innerHTML=orig; btn.disabled=false; return; }

        track('clicked', {step:step, code:code});

        // Activer le bon code
        sessionStorage.setItem('ergosia_upsell_code', code);
        setDiscountInput(code);
        injectBadge();

        // Refresh panier
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));

        // Confirmation dans la carte (le re-render va afficher step 2 si applicable)
        var card = btn.closest('#ergosia-upsell-card');
        if (card) {
          card.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;'
            +'gap:8px;padding:14px;color:#1a7a3c;font-size:13px;font-weight:700;">'
            +'<span style="font-size:18px;">✅</span><span>Produit ajouté !</span></div>';
        }

        // Le cart:refresh re-render le snippet avec l'offre suivante (step 2) — pas besoin de supprimer manuellement
      })
      .catch(function(){ btn.innerHTML=orig; btn.disabled=false; });
      return;
    }
  });

})();